module.exports = __webpack_public_path__ + "static/media/ClassExample.db57ce92.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/iNeed2_Slides/ClassExample.png
// module id = 139
// module chunks = 0